export const RESET = 'EXCMDEVICEBRAND_LIST_RESET'
export const SET_ITEMS = 'EXCMDEVICEBRAND_LIST_SET_ITEMS'
export const SET_ERROR = 'EXCMDEVICEBRAND_LIST_SET_ERROR'
export const SET_VIEW = 'EXCMDEVICEBRAND_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'EXCMDEVICEBRAND_LIST_TOGGLE_LOADING'
